import { Logger } from './logger.service';
import { Injectable, Optional } from '@angular/core';

/**
 * App logger factory service
 *
 * @export
 * @class LoggerProvider
 */
@Injectable({
  providedIn: 'root'
})
export class LoggerProvider {

  private static _logger: Logger;

  constructor(@Optional() logger: Logger) {
    LoggerProvider._logger = logger;
  }

  public static getLogger(): Logger {
    return this._logger;
  }
}
